import { Component } from '@angular/core';

@Component({
    selector: 'ifc-app-bar-expanded',
    templateUrl: './app-bar-expanded.component.html',
    standalone: false
})
export class AppBarExpandedComponent {

  constructor() { }

}
